// Instances storage
export const instances = {};

// The CSS class to use for selected elements
export const selectedClass = 'wysi-selected';